// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__33CRi","footer":"ModalFilter_footer__1YEj4"};